import { p as y } from "./useAccount-8a1c7225.js";
import { u as Le, m as ke } from "./useAccount-8a1c7225.js";
import { useState as c, useCallback as u, useEffect as m, useRef as C, useContext as D } from "react";
import { d as S, e as V, u as M, f as q, a as d, c as E } from "./usehooks-ts-53aa4768.js";
import { ab as ze, ao as Te, af as be, ap as De, aq as Ve, as as Me, v as qe, ar as xe, z as Ne, n as Fe } from "./eMyAsurionProvider-ec3ed988.js";
import "./myasurion-shared.mixpanel.es.js";
import "./contentful-a9b11b75.js";
import "./@firebase-868b0e52.js";
import "./firebase-d0134a8f.js";
import "./node-forge-b3503c74.js";
import { a as x } from "./contentful-ed636ee7.js";
import { a as N } from "./providers-e896aa48.js";
import { u as Ae } from "./providers-e896aa48.js";
import "./domains-162ab8d8.js";
import "./react-944c88e2.js";
import "@tanstack/react-query";
import "react-router-dom";
import "@chakra-ui/react";
import "@chakra-ui/icons";
import "./@chakra-ui-f377b543.js";
import "./lodash.mergewith-9d927056.js";
import "./@contentful-cca97bae.js";
import "@emotion/react";
import "./chakraReact-cc461a14.js";
import "./@zag-js-985153e8.js";
import "framer-motion";
import "./react-fast-compare-e81d3847.js";
import "@emotion/styled";
import "./features-4c20b5b5.js";
import "./axios-d6123f02.js";
import "./myasurion-shared.carrier.es.js";
import "./crypto-js-1bed509f.js";
import "./typescript-collections-b97a1d6d.js";
import "./moment-a2f61e40.js";
import "./browser-detect-b0c87b70.js";
import "./@aws-amplify-21547700.js";
import "./js-cookie-d54fed8f.js";
import "./@aws-crypto-5d5961ee.js";
import "./tslib-1406810b.js";
import "./@smithy-2331ff76.js";
import "./rxjs-c3576f66.js";
import "./uuid-5adc31c9.js";
import "./aws-amplify-2a9a372d.js";
import "./process-481e9afe.js";
import "./myasurion-shared.ereviewSubmission.es.js";
import "./cleave.js-cf58c059.js";
import "./colornames-7577e860.js";
import "./LockIcon-3715d1f2.js";
import "./react-responsive-carousel-5d5a6886.js";
import "./react-easy-swipe-5c12dd2c.js";
import "./prop-types-5dc3ead4.js";
import "./react-is-fdabd8df.js";
import "./object-assign-d7a4d3b1.js";
import "./classnames-0d222af1.js";
import "./lodash-bd0366b5.js";
import "./xstate-03560826.js";
import "./@xstate-e6d7a3e3.js";
import "./use-sync-external-store-9c68af99.js";
import "./use-isomorphic-layout-effect-37cd9e90.js";
import "./file-saver-1aff1f79.js";
import "@react-oauth/google";
import "./formik-a668a7f5.js";
import "./deepmerge-c6c56555.js";
import "./lodash-es-9bce7d1a.js";
import "./tiny-warning-b49e0329.js";
import "./hoist-non-react-statics-0f4f9040.js";
import "./myasurion-shared.widgets.es.js";
import "./yup-c645f9e0.js";
import "./property-expr-5b4294d4.js";
import "./tiny-case-47ef5535.js";
import "./toposort-f63cd5fa.js";
import "./myasurion-shared.profile.es.js";
import "./date-fns-9d457cca.js";
import "./@babel-dad84d6f.js";
const re = (t) => {
  S(() => {
    window.document.title = t;
  }, [t]);
}, F = "(prefers-color-scheme: dark)", oe = (t) => {
  const r = V(F), [n, o] = M(
    "usehooks-ts-dark-mode",
    t ?? r ?? !1
  );
  return q(() => {
    o(r);
  }, [r]), {
    isDarkMode: n,
    toggle: () => o((a) => !a),
    enable: () => o(!0),
    disable: () => o(!1)
  };
};
function ne() {
  const [t, r] = c(null), [n, o] = c({
    width: 0,
    height: 0
  }), a = u(() => {
    o({
      width: (t == null ? void 0 : t.offsetWidth) || 0,
      height: (t == null ? void 0 : t.offsetHeight) || 0
    });
  }, [t == null ? void 0 : t.offsetHeight, t == null ? void 0 : t.offsetWidth]);
  return d("resize", a), S(() => {
    a();
  }, [t == null ? void 0 : t.offsetHeight, t == null ? void 0 : t.offsetWidth]), [r, n];
}
const se = () => {
  const [t, r] = c(!1);
  return { handleImageOnLoad: () => {
    r(!0);
  }, css: {
    // Thumbnail style.
    thumbnail: {
      visibility: t ? "hidden" : "visible",
      filter: "blur(8px)",
      transition: "visibility 0ms ease-out 500ms"
    },
    // Full image style.
    fullSize: {
      opacity: t ? 1 : 0,
      transition: "opacity 500ms ease-in 0ms"
    }
  } };
}, ie = (t, { threshold: r = 0, root: n = null, rootMargin: o = "0%", freezeOnceVisible: a = !1 }) => {
  const [s, e] = c(), i = (s == null ? void 0 : s.isIntersecting) && a, g = ([h]) => {
    e(h);
  };
  return m(() => {
    const h = t == null ? void 0 : t.current;
    if (!!!window.IntersectionObserver || i || !h)
      return;
    const $ = { threshold: r, root: n, rootMargin: o }, I = new IntersectionObserver(g, $);
    return I.observe(h), () => I.disconnect();
  }, [t == null ? void 0 : t.current, JSON.stringify(r), n, o, i]), s;
}, ae = (t, r) => {
  const n = C(t);
  S(() => {
    n.current = t;
  }, [t]), m(() => {
    if (!r && r !== 0)
      return;
    const o = setInterval(() => n.current(), r);
    return () => clearInterval(o);
  }, [r]);
}, ce = () => {
  const t = C(!0);
  return t.current ? (t.current = !1, !0) : t.current;
}, ue = () => {
  const t = C(!1);
  return m(() => (t.current = !0, () => {
    t.current = !1;
  }), []), u(() => t.current, []);
}, de = (t, r) => {
  const n = u(() => {
    if (typeof window > "u")
      return r;
    try {
      const i = window.localStorage.getItem(t);
      return i ? y(i) : r;
    } catch (i) {
      return console.warn(`Error reading localStorage key “${t}”:`, i), r;
    }
  }, [r, t]), [o, a] = c(n), s = E((i) => {
    typeof window > "u" && console.warn(
      `Tried setting localStorage key “${t}” even though environment is not a client`
    );
    try {
      const g = i instanceof Function ? i(o) : i;
      window.localStorage.setItem(t, JSON.stringify(g)), a(g), window.dispatchEvent(new Event("local-storage"));
    } catch (g) {
      console.warn(`Error setting localStorage key “${t}”:`, g);
    }
  });
  m(() => {
    a(n());
  }, []);
  const e = u(
    (i) => {
      i != null && i.key && i.key !== t || a(n());
    },
    [t, n]
  );
  return d("storage", e), d("local-storage", e), [o, s];
}, me = (t) => {
  const r = (s) => typeof window < "u" ? window.matchMedia(s).matches : !1, [n, o] = c(r(t));
  function a() {
    o(r(t));
  }
  return m(() => {
    const s = window.matchMedia(t);
    return a(), s.addListener ? s.addListener(a) : s.addEventListener("change", a), () => {
      s.removeListener ? s.removeListener(a) : s.removeEventListener("change", a);
    };
  }, [t]), n;
}, ge = (t) => {
  const r = u(() => {
    if (typeof window > "u")
      return null;
    try {
      const s = window.localStorage.getItem(t);
      return s ? JSON.parse(s) : null;
    } catch (s) {
      return console.warn(`Error reading localStorage key “${t}”:`, s), null;
    }
  }, [t]), [n, o] = c(r);
  m(() => {
    o(r());
  }, []);
  const a = u(
    (s) => {
      s != null && s.key && s.key !== t || o(r());
    },
    [t, r]
  );
  return d("storage", a), d("local-storage", a), n;
}, pe = () => {
  const t = () => {
    if (typeof window < "u" && window.screen)
      return window.screen;
  }, [r, n] = c(t());
  function o() {
    n(t());
  }
  return d("resize", o), S(() => {
    o();
  }, []), r;
}, we = (t, r) => {
  const n = C(t);
  S(() => {
    n.current = t;
  }, [t]), m(() => {
    if (!r && r !== 0)
      return;
    const o = setTimeout(() => n.current(), r);
    return () => clearTimeout(o);
  }, [r]);
}, fe = (t) => {
  const [r, n] = c(!!t), o = u(() => n((a) => !a), []);
  return [r, o, n];
}, le = () => {
  const [t, r] = c({
    width: 0,
    height: 0
  }), n = () => {
    r({
      width: window.innerWidth,
      height: window.innerHeight
    });
  };
  return d("resize", n), S(() => {
    n();
  }, []), t;
}, p = "initializeData", k = "session-storage", he = (t) => {
  const r = u(() => {
    if (typeof window > "u")
      return t;
    try {
      const e = window.sessionStorage.getItem(p);
      return e ? y(e) : t;
    } catch (e) {
      return console.warn(`Error reading service request data “${p}”:`, e), t;
    }
  }, [t, p]), [n, o] = c(r), a = E((e) => {
    typeof window > "u" && console.warn(
      `Tried setting service request data “${p}” even though environment is not a client`
    );
    try {
      const i = e instanceof Function ? e(n) : e;
      window.sessionStorage.setItem(p, JSON.stringify(i)), o(i), window.dispatchEvent(new Event(k));
    } catch (i) {
      console.warn(`Error setting service request data key “${p}”:`, i);
    }
  });
  m(() => {
    o(r());
  }, []);
  const s = u(
    (e) => {
      e != null && e.key && e.key !== p || o(r());
    },
    [p, r]
  );
  return d("storage", s), d(k, s), [n, a];
}, w = "interactionData", v = "session-storage", Se = (t) => {
  const r = u(() => {
    if (typeof window > "u")
      return t;
    try {
      const e = window.sessionStorage.getItem(w);
      return e ? y(e) : t;
    } catch (e) {
      return console.warn(`Error reading service request data “${w}”:`, e), t;
    }
  }, [t, w]), [n, o] = c(r), a = E((e) => {
    typeof window > "u" && console.warn(
      `Tried setting service request data “${w}” even though environment is not a client`
    );
    try {
      const i = e instanceof Function ? e(n) : e;
      window.sessionStorage.setItem(w, JSON.stringify(i)), o(i), window.dispatchEvent(new Event(v));
    } catch (i) {
      console.warn(`Error setting service request data key “${w}”:`, i);
    }
  });
  m(() => {
    o(r());
  }, []);
  const s = u(
    (e) => {
      e != null && e.key && e.key !== w || o(r());
    },
    [w, r]
  );
  return d("storage", s), d(v, s), [n, a];
}, f = "agreementData", z = "session-storage", ye = (t) => {
  const r = u(() => {
    if (typeof window > "u")
      return t;
    try {
      const e = window.sessionStorage.getItem(f);
      return e ? y(e) : t;
    } catch (e) {
      return console.warn(`Error reading service request data “${f}”:`, e), t;
    }
  }, [t, f]), [n, o] = c(r), a = E((e) => {
    typeof window > "u" && console.warn(
      `Tried setting service request data “${f}” even though environment is not a client`
    );
    try {
      const i = e instanceof Function ? e(n) : e;
      window.sessionStorage.setItem(f, JSON.stringify(i)), o(i), window.dispatchEvent(new Event(z));
    } catch (i) {
      console.warn(`Error setting service request data key “${f}”:`, i);
    }
  });
  m(() => {
    o(r());
  }, []);
  const s = u(
    (e) => {
      e != null && e.key && e.key !== f || o(r());
    },
    [f, r]
  );
  return d("storage", s), d(z, s), [n, a];
}, l = "determineIncidentData", T = "session-storage", Ee = (t) => {
  const r = u(() => {
    if (typeof window > "u")
      return t;
    try {
      const e = window.sessionStorage.getItem(l);
      return e ? y(e) : t;
    } catch (e) {
      return console.warn(`Error reading service request data “${l}”:`, e), t;
    }
  }, [t, l]), [n, o] = c(r), a = E((e) => {
    typeof window > "u" && console.warn(
      `Tried setting service request data “${l}” even though environment is not a client`
    );
    try {
      const i = e instanceof Function ? e(n) : e;
      window.sessionStorage.setItem(l, JSON.stringify(i)), o(i), window.dispatchEvent(new Event(T));
    } catch (i) {
      console.warn(`Error setting service request data key “${l}”:`, i);
    }
  });
  m(() => {
    o(r());
  }, []);
  const s = u(
    (e) => {
      e != null && e.key && e.key !== l || o(r());
    },
    [l, r]
  );
  return d("storage", s), d(T, s), [n, a];
}, Ie = (t = {}, r = "", n = "", o = "", a = "", s = {}, e = !1) => {
  const [i, g] = c([]), [h, O] = c(!1), [$, I] = c(null), b = JSON.stringify(t);
  return m(() => {
    O(!0), (async () => {
      try {
        const L = await x(
          t,
          r,
          n,
          o,
          a,
          s,
          e
        );
        g(L);
      } catch (L) {
        I(L);
      } finally {
        O(!1);
      }
    })();
  }, [b]), {
    contentfulEntry: i,
    contentfulEntryLoading: h,
    errors: $
  };
}, Ce = () => {
  const t = D(N);
  if (!t)
    throw new Error("useCognitoAuth must be used within a CogntioAuthProvider");
  return t;
};
export {
  Le as useAccount,
  ye as useAgreementData,
  ke as useAuthToken,
  Ce as useCognitoAuth,
  Ae as useCognitoAuthProvider,
  Ie as useContentfulEntry,
  ze as useContentfulImage,
  oe as useDarkMode,
  Ee as useDetermineIncidentData,
  re as useDocumentTitle,
  ne as useElementSize,
  Te as useFeatureIsOn,
  be as useHeader,
  se as useImageOnLoad,
  he as useInitializeData,
  Se as useInteractionData,
  ie as useIntersectionObserver,
  ae as useInterval,
  De as useIsDisabledFeature,
  ce as useIsFirstRender,
  ue as useIsMounted,
  de as useLocalStorage,
  me as useMediaQuery,
  Ve as useNotifications,
  ge as useReadLocalStorage,
  pe as useScreen,
  Me as useScrollBlock,
  qe as useSessionStorage,
  xe as useSlots,
  Ne as useTextScript,
  Fe as useTextTranslation,
  we as useTimeout,
  fe as useToggle,
  le as useWindowSize
};
